import { render, staticRenderFns } from "./CustomerGroupSelect.vue?vue&type=template&id=28cffdfa&"
import script from "./CustomerGroupSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports